import styled from 'styled-components';

const StyledMedicalLeaveFormCodesDescriptions = styled.div`
   flex-basis: 100%;
   margin-top: 12px;
`;
StyledMedicalLeaveFormCodesDescriptions.displayName = 'StyledMedicalLeaveFormCodesDescriptions';

export { StyledMedicalLeaveFormCodesDescriptions };
